import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, borderRadius }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: ${theme.v3.colors.neutral[100]};
    border-radius: ${borderRadius};
    padding: 40px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 24px;
    }
  `}
`;

export const LoaderWrapper = styled.div`
  ${({ $isLoaderBuilder }) => css`
    width: ${!$isLoaderBuilder ? '120px' : 'fit-content'};
    display: flex;
    justify-content: center;
    position: relative;
  `}
`;

export const ProgressBarContainer = styled.div`
    background-color: #E7F3FD;
    border-radius: 4px;
    height: 6px;
    width: 120px;
    position: absolute;
    bottom: 0px;
    z-index: 2;
`;

export const Progress = styled.div`
  ${({ percentage }) => css`
    background-color: #74C1FF;
    border-radius: 4px;
    height: 100%;
    width: ${`${percentage}%`};
    transition: width 0.4s ease-out;
  `}
`;

export const LoaderTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    font-weight: ${theme.v3.font.weights.medium};
    letter-spacing: 0px;
    margin: 24px 0px 0px 0px;
    text-align: center;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.medium};
    }
  `}
`;

export const LoaderDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    letter-spacing: 0px;
    margin: 8px 0px 0px 0px;
    text-align: center;
    max-width: 540px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }    
  `}
`;

export const LoaderBuilderImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;
